import { ConsumerPostSubmissionApprovedState } from './consumer-post-submission-approved.state'

export const createConsumerPostSubmissionApprovedState =
  (): ConsumerPostSubmissionApprovedState => {
    return {
      applicantLink: null,
      error: null
    }
  }
